import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { AdType } from '@src/app/enum/ad-type.enum';

@Component({
  selector: 'app-ad-typical-ui',
  templateUrl: './ad-typical-ui.component.html',
  styleUrls: ['./ad-typical-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdTypicalUiComponent {

  @Input() public type: AdType;
  @Output() public onClickAd$: EventEmitter<AdType> = new EventEmitter();

  public readonly AD_TYPE = AdType;

  constructor() { }
}
